import React, { Component } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { translate } from "react-i18next"
import { formatDecimalForDisplay } from "../../../utils/formatting-utils"

const BoxContainer = styled.div`
  display: inline-block;
  ${props => (props.isSmall9BG ? "padding: 5px !important" : "padding-top: 10px !important")};
`

const StatisticContainer = styled.div`
  height: ${props => (props.isSmall9BG ? "82px" : "125px")};
  border: 1px lightgrey solid;
  color: black;
  background: ${props => props.colour};
  text-align: center;
`
const ComparisonContainer = styled.div`
  height: 25px;
  border: 1px lightgrey solid;
  border-top: none;
  color: black;
  font-size: 14px;
  background: ${props => props.comparisonColour};
  text-align: center;
`

class Box extends Component {
  state = {
    hover: false
  }

  changeHexColor = (col, amt) => {
    let usePound = false

    if (col[0] === "#") {
      col = col.slice(1)
      usePound = true
    }

    const num = parseInt(col, 16)

    let r = (num >> 16) + amt

    if (r > 255) r = 255
    else if (r < 0) r = 0

    let b = ((num >> 8) & 0x00ff) + amt

    if (b > 255) b = 255
    else if (b < 0) b = 0

    let g = (num & 0x0000ff) + amt

    if (g > 255) g = 255
    else if (g < 0) g = 0

    return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16)
  }
  toggleHoverOn = () => {
    this.setState({ hover: true })
  }
  toggleHoverOff = () => {
    this.setState({ hover: false })
  }

  clickEvent = () => {
    const { boxIndex, title, count, onClickEvent } = this.props
    onClickEvent(boxIndex, title, count)
  }

  render() {
    const {
      t,
      title,
      boxIndex,
      count,
      percentage,
      colour,
      isSmall9BG,
      includeComparison,
      comparisonPercentage
    } = this.props

    const comparisonColour = this.changeHexColor(colour, 15)
    const hoverColour = this.changeHexColor(colour, -20)

    const getComparisonText = () => {
      let text = ""

      if (percentage === comparisonPercentage) {
        text = t("Common.SameAs")
      } else if (percentage > comparisonPercentage) {
        const numerial = formatDecimalForDisplay(percentage - comparisonPercentage)
        text = `${numerial}% ${t("Common.UpOn")}`
      } else if (percentage < comparisonPercentage) {
        const numerial = formatDecimalForDisplay(comparisonPercentage - percentage)
        text = `${numerial}% ${t("Common.DownOn")}`
      }

      return `${text} ${t("Common.PreviousReview")}`
    }

    const getComparisonSymbol = () => {
      let output = ""

      if (percentage === comparisonPercentage) {
        output = "mdi mdi-minus"
      } else if (percentage > comparisonPercentage) {
        output = "mdi mdi-arrow-up-bold"
      } else if (percentage < comparisonPercentage) {
        output = "mdi mdi-arrow-down-bold"
      }

      return output
    }

    let boxStyle
    let statisticContainerStyle

    if (this.state.hover) {
      boxStyle = { cursor: "pointer" }
      statisticContainerStyle = { background: hoverColour }
    } else {
      boxStyle = { cursor: "default" }
    }

    let descriptorTranslation = "Common.People"

    if (count === 1) {
      descriptorTranslation = "Common.Person"
    }

    return (
      <BoxContainer
        id={`9bgBox${boxIndex}`}
        isSmall9BG={isSmall9BG}
        className="box col-lg-4 col-md-4"
        style={boxStyle}
        onClick={this.clickEvent}
        onMouseEnter={this.toggleHoverOn}
        onMouseLeave={this.toggleHoverOff}
      >
        <StatisticContainer style={statisticContainerStyle} isSmall9BG={isSmall9BG} colour={colour}>
          <p
            style={{
              paddingTop: isSmall9BG ? "10px" : "30px",
              fontSize: isSmall9BG ? "14px" : "18px"
            }}
          >
            {t(title)}
          </p>
          <p style={{ fontSize: isSmall9BG ? "12px" : "16px" }}>
            {count} {t(descriptorTranslation)} ({formatDecimalForDisplay(percentage)}%)
          </p>
        </StatisticContainer>
        {includeComparison && (
          <ComparisonContainer comparisonColour={comparisonColour}>
            <span>
              <i className={getComparisonSymbol()} /> {getComparisonText()}
            </span>
          </ComparisonContainer>
        )}
      </BoxContainer>
    )
  }
}

Box.propTypes = {
  isSmall9BG: PropTypes.bool,
  title: PropTypes.string.isRequired,
  boxIndex: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  percentage: PropTypes.number.isRequired,
  colour: PropTypes.string.isRequired,
  includeComparison: PropTypes.bool,
  comparisonPercentage: PropTypes.number,
  onClickEvent: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}

Box.defaultProps = {
  isSmall9BG: false,
  includeComparison: false,
  comparisonPercentage: 0
}

export default translate()(Box)



// WEBPACK FOOTER //
// ./src/components/charts/nine-box-grid/Box.jsx